import axios from 'axios'

export default {
  state: {
    productsInfo: {},
    characteristicsList: {},
    selectedCategory: null,
    selectedShowType: 1,
    isInfoLoading: false,
    comparisonInfoHeader: null,
    whichToComparePopupInfo: null
  },
  getters: {
    characteristicsList ({ selectedShowType, productsInfo }) {
      const onlyDifferentList = {}

      if (selectedShowType === 2) {
        for (const productHash in productsInfo.c_data) {
          if (productsInfo.c_data[productHash].different) {
            onlyDifferentList[productHash] = productsInfo.c_data[productHash]
          }
        }
        return onlyDifferentList
      } else {
        return productsInfo.c_data
      }
    },
    accessoriesList ({ selectedShowType, productsInfo }) {
      const onlyDifferentList = {}

      if (!productsInfo.a_data) return onlyDifferentList

      if (selectedShowType === 2) {
        for (const productHash in productsInfo.a_data) {
          if (productsInfo.a_data[productHash].different) {
            onlyDifferentList[productHash] = productsInfo.a_data[productHash]
          }
        }
        return onlyDifferentList
      } else {
        return productsInfo.a_data
      }
    },
    onlyAvailableCategoriesList ({ comparisonInfoHeader }) {
      const filteredList = {}
      const { data } = comparisonInfoHeader

      for (const categoryKey in data) {
        filteredList[categoryKey] = data[categoryKey]
      }
      return filteredList
    },
    productsToComparison ({ comparisonInfoHeader }) {
      if (!comparisonInfoHeader) return []

      const productsIds = []
      const { data } = comparisonInfoHeader
      for (const categoryId in data) {
        for (const productId in data[categoryId].product_list) {
          productsIds.push(productId)
        }
      }
      return productsIds
    }
  },
  mutations: {
    SET_COMPARE_PRODUCTS_INFO (state, data) {
      state.productsInfo = data
    },
    SET_SELECTED_CATEGORY (state, data) {
      state.selectedCategory = data
    },
    SET_ACTIVE_SHOW_TYPE (state, showTypeId) {
      state.selectedShowType = showTypeId
    },
    SET_IS_INFO_LOADING (state, bool) {
      state.isInfoLoading = bool
    },
    SET_COMPARISON_INFO_HEADER (state, info) {
      state.comparisonInfoHeader = info
    },
    SET_WHICH_TO_COMPARE_MODAL_INFO (state, info) {
      state.whichToComparePopupInfo = info
    }
  },
  actions: {
    FETCH_COMPARISON_INFO ({ commit, rootGetters }) {
      commit('SET_IS_INFO_LOADING', true)

      const urlParams = new URLSearchParams(window.location.search)
      const params = urlParams.get('ids')
      axios
        .get(rootGetters.urlLanguagePrefix + '/comparison/get-products/?ids=' + params)
        .then(response => {
          if (!response.data) {
            commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred'))
          }
          commit('SET_COMPARE_PRODUCTS_INFO', response.data)
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred')))
        .finally(() => commit('SET_IS_INFO_LOADING', false))
    },
    SET_SELECTED_CATEGORY_ACTION ({ commit, state, dispatch }, category) {
      commit('SET_SELECTED_CATEGORY', category)

      const { comparisonInfoHeader, selectedCategory } = state
      const selectedCategoryUrl = comparisonInfoHeader.data[selectedCategory].compare_url
      history.replaceState(null, null, selectedCategoryUrl)
      dispatch('FETCH_COMPARISON_INFO')
    },
    SET_ACTIVE_SHOW_TYPE_ACTION ({ commit }, type) {
      commit('SET_ACTIVE_SHOW_TYPE', type)
    },
    ADD_TO_COMPARISON_ACTION ({ commit, rootGetters, dispatch }, url) {
      return new Promise(resolve => {
        axios
          .post(url)
          .then(response => {
            if (response.data.status === 'success') {
              commit('SET_COMPARISON_INFO_HEADER', response.data)
            } else if (response.data.status === 'error') {
              commit('SET_ERROR_FROM_SERVER', response.data.message)
            }
            resolve(response.data)
          })
          .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred')))
      })
    },
    FETCH_COMPARISON_INFO_HEADER ({ commit, rootGetters, dispatch }) {
      axios
        .get(rootGetters.urlLanguagePrefix + '/comparison/info/')
        .then(response => {
          commit('SET_COMPARISON_INFO_HEADER', response.data)

          const categories = response.data.data
          let sendFetch = true

          for (const categoryId in categories) {
            for (const productId in categories[categoryId].product_list) {
              if (window.location.pathname.includes('comparison')) {
                const urlParams = new URLSearchParams(window.location.search)
                const params = urlParams.get('ids')

                if (!params) {
                  dispatch('SET_SELECTED_CATEGORY_ACTION', categoryId)
                  sendFetch = false
                  break
                } else if (params && params.split(',')[0] === productId) {
                  dispatch('SET_SELECTED_CATEGORY_ACTION', categoryId)
                  sendFetch = false
                }
              }
            }
          }
          if (sendFetch && window.location.pathname.includes('comparison')) {
            dispatch('FETCH_COMPARISON_INFO')
          }
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred')))
    },
    REMOVE_PRODUCT_FROM_COMPARISON ({ ctx, rootGetters, dispatch, commit, state }, data) {
      return new Promise(resolve => {
        const { productId, url } = data

        if (window.location.pathname.includes('comparison')) {
          const urlParams = new URLSearchParams(window.location.search)
          const params = urlParams.get('ids').split(',')

          params.forEach((el, i) => {
            if (el === productId || (el.includes(':') && el.split(':')[1] === productId)) params.splice(i, 1)
          })
          history.replaceState(null, null, '/comparison/?ids=' + params.join())
        }
        axios
          .post(url)
          .then(response => {
            if (window.location.pathname.includes('comparison')) {
              let currentCategoryProductList = {}

              if ((Object.keys(response.data.data).length || response.data.data.length) && response.data.data[state.selectedCategory]) {
                currentCategoryProductList = response.data.data[state.selectedCategory].product_list
              }

              if (!Object.keys(currentCategoryProductList).length) {
                dispatch('SET_OTHER_CATEGORY', response.data)
              } else {
                dispatch('FETCH_COMPARISON_INFO')
              }
            }
            commit('SET_COMPARISON_INFO_HEADER', response.data)
            resolve(response.data)
          })
          .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred')))
      })
    },
    REMOVE_CATEGORY_FROM_COMPARISON ({ commit, rootGetters, dispatch }, url) {
      axios
        .post(url)
        .then(({ data }) => {
          if (data.status === 'success') {
            commit('SET_COMPARISON_INFO_HEADER', data)
          } else if (data.status === 'error') {
            commit('SET_ERROR_FROM_SERVER', data.message)
          }
          dispatch('SET_OTHER_CATEGORY', data)
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred')))
    },
    SET_WHICH_TO_COMPARE_MODAL_INFO_ACTION ({ commit }, info) {
      commit('SET_WHICH_TO_COMPARE_MODAL_INFO', info)
    },
    SET_OTHER_CATEGORY ({ commit, dispatch }, categories) {
      let otherCategoryIsset = false
      if (window.location.pathname.includes('comparison') && Object.keys(categories.data)[0]) {
        for (const categoryId in categories.data) {
          const currentProductList = categories.data[categoryId].product_list
          if (Object.keys(currentProductList).length) {
            otherCategoryIsset = true
            dispatch('SET_SELECTED_CATEGORY_ACTION', categoryId)
            break
          }
        }
      }
      if (!otherCategoryIsset) commit('SET_COMPARE_PRODUCTS_INFO', { status: 'error' })
    }
  }
}
